import { datajs, datajsAll } from '../shared/utils';
import { Modal } from 'bootstrap';

export default class VideoGridBlock {
	static init() {
		const videoItems = datajsAll('video-item');

		videoItems.forEach((videoItem) => {
			this.videoModal(videoItem);
		});
	}

	// Setup Modal
	static videoModal(videoItem) {
		const buttons = datajsAll('video-slide-play-button', videoItem);
		const videoModalElement = datajs('video-modal', videoItem);
		const videoModalElementContent = datajs('video-modal-content', videoItem);
		const videoModal = new Modal(videoModalElement);

		// Show modal event
		videoModalElement.addEventListener('shown.bs.modal', function () {
			const videoElement = videoModalElementContent.querySelector('video');
			const iframe = videoModalElementContent.querySelector('iframe');

			if (videoElement) {
				videoElement.play();
			} else if (iframe) {
				iframe.setAttribute('src', iframe.dataset.src + '&autoplay=1');
			}
		});

		// Hide modal event
		videoModalElement.addEventListener('hidden.bs.modal', function () {
			const videoElement = videoModalElementContent.querySelector('video');
			const iframe = videoModalElementContent.querySelector('iframe');

			if (videoElement) {
				videoElement.pause();
			} else if (iframe) {
				iframe.removeAttribute('src');
			}
		});

		buttons.forEach((button) => {
			const currentVideoItem = button.closest('[data-js~=video-item]');
			const currentVideoElement = datajs('video-item-video', currentVideoItem);

			button.addEventListener('click', function (e) {
				e.preventDefault();
				videoModalElementContent.innerHTML = currentVideoElement.innerHTML;
				videoModal.show();
			});
		});
	}
}
